var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-ellipse-progress',{attrs:{"progress":_vm.progress,"color":_vm.color,"size":_vm.size,"thickness":"12%","empty-thickness":"12%"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }